import { render, staticRenderFns } from "./ModalFormaDePago.vue?vue&type=template&id=5a481528&scoped=true"
import script from "./ModalFormaDePago.vue?vue&type=script&lang=js"
export * from "./ModalFormaDePago.vue?vue&type=script&lang=js"
import style0 from "./ModalFormaDePago.vue?vue&type=style&index=0&id=5a481528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a481528",
  null
  
)

export default component.exports